import React from "react";
import { func } from "prop-types";
import {
  Button,
  Input,
  Card,
  CardBody,
  Table,
  Form,
  FormGroup,
  Label,
  Col,
  Row,
  DropdownItem
} from "reactstrap";
import NumericInput from 'react-numeric-input';
import Spinner from "COMPONENTS/Spinner/Spinner";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";
// import HeaderContainer from "../Header/HeaderContainer";

//Daterangepicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

//Constant
import { modulesAvailableConstant, cobrowseTypes , modulesToDisplay, LOG_TYPE, STORAGE_LOCATION, BUSINESS_MODELS, STORAGE } from "../../../Utils/Constants";
import { getTomorrowDate, isValidDate } from "UTILS/DateUtils";
import { addLeadingSlash } from "history/PathUtils";

// Images
import ic_audio from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_canvas from "ASSETS/Images/header_center/ic_canvas_deactivate.svg";
import ic_message from "ASSETS/Images/header_center/ic_message_deactivate.svg";
import ic_video from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_share from "ASSETS/Images/header_center/ic_share_deactivate.svg";
import ic_location from "ASSETS/Images/header_center/ic_location_deactivate.svg";
import ic_pdf from "ASSETS/Images/pdf/ic_pdf.svg";
import ic_camera from "ASSETS/Images/header_center/ic_snapshot_deactivate.svg";
import ic_admin_co_browse from "ASSETS/Images/header_center/ic_co_browse_deactivate.svg";
import ic_QR_code from "ASSETS/Images/ic_QR_code.svg";
import download_img from "ASSETS/Images/ic_download_allow.svg";
import ic_error from "ASSETS/Images/ic_error.svg";
import ic_edit from "ASSETS/Images/ic_edit.svg";
import ic_add_storage from "ASSETS/Images/ic_add_storage.svg";
import ic_app_emulation from "ASSETS/Images/ic_app_emulation_small.svg";

//actions
// Strings
import { getMessage } from "CONFIG/i18n";
import {
  validateUserName,
  validateNumber
} from "UTILS/regexValidations";
import { isAlphaNumeric ,hasWhiteSpace} from "UTILS/Utility";
// import validator from "validator";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import 'react-dates/lib/css/_datepicker.css';
import "./../Organisations/Organisations.less";

class AddOrganisation extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };

  constructor(props) {
    super(props);
    this.state = {
      OrgDetail: {
        name: "",
        seats: "",
        availableModules: [],
        firstName: "",
        lastName: "",
        username: "",
        uriIdentifier: "",
        licenseExpiryDate: getTomorrowDate(),
        currentDate: "",
        qrLimit: "",
        loggingLevel: LOG_TYPE.BASIC,
        businessModel: BUSINESS_MODELS.NUMBER_OF_SEATS,
        maxConcurrentConnections: "",
        cobrowseType: cobrowseTypes.CUSTOMER_CO_BROWSE,
      },
      isSSOEnabled: false,
      role: "ADMIN",
      errorMessage: "",
      storageChanged: false,
      currentBucket: "",
      storage: {
        storageDetails: {
          location: STORAGE_LOCATION.CUSTOMER,
          type: "S3",
          list: []
        }
      },
      recordingStorage: { 
        storageDetails: {
          location: STORAGE_LOCATION.CUSTOMER,
          type: "S3",
          list: []
        }
      },
      focused: null,
      isPasscodeEnabled: false,
      isOrganizationTemplatesEnabled: false,
      showSystemCapacity: false,
      isSMSEnabled: false,
      isMfaEnabled: false,
    };
  }

  componentDidMount() {
    this.selectDefaultStorage(-1, "storage");
    this.selectDefaultStorage(-1, "recordingStorage");
    this.resetAddOrgState();
  }

  componentDidUpdate(preProps) {
    if (this.props.errorMessage !== preProps.errorMessage) {
      this.setState({ errorMessage: this.props.errorMessage });
    }
  }

  handleAddClick = () => {
    if (!this.isValidData()) {
      return;
    }
    let qrLimit = this.state.OrgDetail.availableModules.indexOf("QR_CODE") != -1
      && this.state.OrgDetail.qrLimit && this.state.OrgDetail.qrLimit != ""
      ? this.state.OrgDetail.qrLimit : undefined;
    let data = Object.assign(
      {},
      {
        customerName: this.state.OrgDetail.name,
        customerSeats: this.state.OrgDetail.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS 
          ? this.state.OrgDetail.seats 
          : undefined,
        maxConcurrentSessions: this.state.OrgDetail.businessModel === BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS
          ? this.state.OrgDetail.maxConcurrentConnections
          : undefined,
        businessModel: this.state.OrgDetail.businessModel,
        customerAvailableModules: this.state.OrgDetail.availableModules,
        customerLicenseExpiryDate: this.state.OrgDetail.licenseExpiryDate.format("YYYY-MM-DD"),
        customerQrLimit: qrLimit,
        customerLoggingLevel: this.state.OrgDetail.loggingLevel,
        adminFirstName: this.state.OrgDetail.firstName,
        adminLastName: this.state.OrgDetail.lastName,
        adminUsername: this.state.OrgDetail.username,
        storageDetails: this.state.storage.storageDetails,
        recordingStorageDetails: this.state.recordingStorage.storageDetails,
        isSSOEnabled:this.state.isSSOEnabled,
        language: this.props.language,
        isPasscodeEnabled: this.state.isPasscodeEnabled,
        isOrganizationTemplatesEnabled:this.state.isOrganizationTemplatesEnabled,
        uriIdentifier: this.state.OrgDetail.uriIdentifier,
        cobrowseType: this.state.OrgDetail.availableModules.includes(modulesAvailableConstant.CO_BROWSE) ? this.state.OrgDetail.cobrowseType : null,
        isSMSEnabled:this.state.isSMSEnabled,
        isMfaEnabled: this.state.isMfaEnabled,
      }
    );
    this.props.handleAddOrganization(data, errorMessage => {
      this.setState({ errorMessage: errorMessage });
    });
  };

  isValidData = () => {
    let OrgDetail = this.state.OrgDetail;
    if (!OrgDetail.name || !OrgDetail.name.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_ORG_NAME") });
      return false;
    }
    if (OrgDetail.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS && 
       (!OrgDetail.seats || OrgDetail.seats < 1 || !validateNumber(OrgDetail.seats)) ) {
      OrgDetail['seats'] = 0;
      this.setState({
        errorMessage: getMessage("SEAT_ERROR_MSG"),
        OrgDetail: OrgDetail
      });
      return false;
    } else if (OrgDetail.businessModel === BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS &&
       (!OrgDetail.maxConcurrentConnections || OrgDetail.maxConcurrentConnections < 1 || !validateNumber(OrgDetail.maxConcurrentConnections)) ) {
      OrgDetail['maxConcurrentConnections'] = 0;
      this.setState({
        errorMessage: getMessage("MAX_CONCURRENT_CONNECTIONS_ERROR_MSG"),
        OrgDetail: OrgDetail
      });
      return false;
    }
    if (!OrgDetail.licenseExpiryDate || !isValidDate(OrgDetail.licenseExpiryDate)) {
      this.setState({ errorMessage: getMessage("INVALID_DATE") });
      return false;
    }
    if (!OrgDetail.username || !OrgDetail.username.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_EMAIL") });
      return false;
    } else {
      if (!validateUserName(OrgDetail.username)) {
        this.setState({ errorMessage: getMessage("INVALID_EMAIL") });
        return false;
      }
    }
    if (!OrgDetail.firstName || !OrgDetail.firstName.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_FIRST_NAME") });
      return false;
    }
    if (!OrgDetail.lastName || !OrgDetail.lastName.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_LAST_NAME") });
      return false;
    }
    if (this.state.OrgDetail.availableModules.indexOf("QR_CODE") !== -1
      && (OrgDetail.qrLimit <= 0 || OrgDetail.qrLimit > 10  || !OrgDetail.qrLimit || !validateNumber(OrgDetail.qrLimit))) {
      let OrgDetail = this.state.OrgDetail; 
      OrgDetail['qrLimit'] = 0;
      this.setState({
        errorMessage: getMessage("QR_LIMIT_ERROR_MSG"),
        OrgDetail: OrgDetail
      });
      return false;
    }
    if (this.state.OrgDetail.uriIdentifier) {
      if (!isAlphaNumeric(this.state.OrgDetail.uriIdentifier)) {
        this.setState({ errorMessage: getMessage("SPECIAL_CHARACTERS_ERROR") });
        return false;
      }
    }
    if((this.state.isPasscodeEnabled || this.state.isSSOEnabled) 
      && _.isEmpty(OrgDetail.uriIdentifier)) {
      this.setState({ errorMessage: getMessage("EMPTY_URI_IDENTIFIER") });
      return false;
    }
    // if (this.state.OrgDetail.loggingLevel == LOG_TYPE.ADVANCED
    //   && (this.state.storageDetails.location===STORAGE_LOCATION.LOOOKIT_CUSTOM && !this.state.isStorageSelected)) {
    //   this.setState({ errorMessage: getMessage("INVALID_STORAGE_OPTION") });
    //   return false;
    // }
    return true;
  };

  handleCancelClick = () => {
    this.resetAddOrgState();
    this.props.handleCancelClick();
  };

  handleNumberInputChange = (name, value, maxLimit) => {
    let OrgDetail = this.state.OrgDetail;
    if(!Number.isInteger(value) || value > maxLimit) {
      OrgDetail[name] = this.state.OrgDetail[name];
      this.setState({
        OrgDetail: OrgDetail
      });
      return;
    }
    
    OrgDetail[name] = value;
    this.setState({ OrgDetail: OrgDetail, errorMessage: "", showSystemCapacity: true });
  }

  handleInputChange = event => {
    let OrgDetail = {...this.state.OrgDetail};
    if(event.target.name === "uriIdentifier" && hasWhiteSpace(event.target.value)) {
      OrgDetail[event.target.name] = event.target.value.trim();
    } else if(event.target.name === "businessModel") {
      OrgDetail["seats"] = "";
      OrgDetail["maxConcurrentConnections"] = "";
      OrgDetail[event.target.name] = event.target.value;
    } else {
      OrgDetail[event.target.name] = event.target.value;
    }

    this.setState({ OrgDetail: OrgDetail, errorMessage: "" });
  };

  handleDateChange = (date) => {
    let stateObject = {...this.state};
    let OrgDetail = stateObject.OrgDetail;
    OrgDetail.licenseExpiryDate = date;
    this.setState({ OrgDetail: OrgDetail, errorMessage: "" });
  }

  changeModulePermission = event => {
    let state_element = this.state.OrgDetail.availableModules;

    if (event.target.checked && !(event.target.name in state_element)) {

      state_element.push(event.target.name);
    } else if (!event.target.checked) {
      state_element = _.remove(state_element, item => {
        if (item !== event.target.name) return item;
      });
    }
    let OrgDetail = this.state.OrgDetail;
    OrgDetail.availableModules = state_element;
    this.setState({ OrgDetail: OrgDetail, errorMessage: "" });
  };

  resetAddOrgState = () => {
    this.setState({
      OrgDetail: {
        name: "",
        seats: "",
        availableModules: [],
        firstName: "",
        lastName: "",
        username: "",
        uriIdentifier: null,
        licenseExpiryDate: getTomorrowDate(),
        currentDate: this.getCurrentDate(),
        qrLimit: "",
        loggingLevel: LOG_TYPE.BASIC,
        storageLocation: STORAGE_LOCATION.CUSTOMER,
        businessModel: BUSINESS_MODELS.NUMBER_OF_SEATS,
        maxConcurrentConnections: "",
        cobrowseType: cobrowseTypes.CUSTOMER_CO_BROWSE,
      },
      errorMessage: "",
      addOrgErrorMessage: "",
      storageErrorMessage: "",
      isSSOEnabled: false,
      isVerified: false,
      isAddStorage: false,
      isEditStorage: false,
      bucketName: "",
      id: "",
      secret: "",
      storage: {
        storageDetails: {
          location: STORAGE_LOCATION.CUSTOMER,
          type: "S3",
          list: []
        }
      },
      recordingStorage: { 
        storageDetails: {
          location: STORAGE_LOCATION.CUSTOMER,
          type: "S3",
          list: []
        }
      },
      storageChanged: false,
      isPasscodeEnabled: false,
      isOrganizationTemplatesEnabled:false,
      isSMSEnabled: false,
    });
  };

  handleS3InputChange = (event, targetStorage) => {
    if(!hasWhiteSpace(event.target.value)) {
      this.setState({
        [targetStorage]:{
          ...this.state[targetStorage],
          [event.target.name]: event.target.value,
          isVerified: false
        }
      },
      () => {this.resetError(targetStorage)});
    }
  }

  getCurrentDate = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    return today;
  };

  selectDefaultStorage = (selectedStorageDetailIndex, targetStorage) => {
    let storageDetailsList = this.state[targetStorage]?.storageDetails?.list ? this.state[targetStorage]?.storageDetails?.list.slice() : [];
    let valid = false;
    let storageState = _.cloneDeep(this.state[targetStorage]);
    if (!this.state[targetStorage].isStorageSelected && this.state.errorMessage){
      this.setState({ errorMessage: "" })
    }
    if (selectedStorageDetailIndex != -1) {
      let newStorageDetailsList = storageDetailsList
      storageDetailsList.forEach((storageDetails, index) => {
        if (index === selectedStorageDetailIndex) {
          newStorageDetailsList[index].isSelected = true;
          valid = true;
          storageState.storageChanged = true;
        } else {
          newStorageDetailsList[index].isSelected = false;
        }
      });
      storageState.storageDetails.list = newStorageDetailsList;
    }
    else {
      storageDetailsList.forEach((storageDetails, index) => {
        if (storageDetails.isSelected) {
          valid = true;
        }
      });
    }
    this.setState({
      [targetStorage]: {
        ...storageState,
        storageErrorMessage: "",
        isStorageSelected: valid
      }
    });
  }
  
  resetStorageDetailsFields = (targetStorage) => {
    this.setState((state, props) => {
      return{
        [targetStorage]: {
          ...state[targetStorage],
          isVerified: false,
          isAddStorage: false,
          isEditStorage: false,
          bucketName: "",
          id: "",
          secret: "",
          storageChanged: false,
          currentBucket: "",
        }
      }
    });
  }

  resetError = (targetStorage) => {
    this.setState((state, props) => {
      return{
        [targetStorage]: {
          ...state[targetStorage],
          storageErrorMessage: "",
          addOrgErrorMessage: ""
        },
        errorMessage: "",
      }
    });
  }

  handleEditStorageClick(bucketName, targetStorage) {
    let bucket = null;
    if (!_.isEmpty(bucketName)) {
      bucket = this.state[targetStorage].storageDetails.list?.filter((item => item.credential.bucketName === bucketName))[0];
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          isEditStorage: true,
          bucketName: bucket.credential.bucketName,
          id: bucket.credential.id,
          secret: bucket.credential.secret,
          currentBucket: bucket.credential.bucketName
        }
      });
    }
  }

  addStorage = (targetStorage) => {
    if (!this.state[targetStorage].bucketName && !this.state[targetStorage].id && !this.state[targetStorage].secret) {
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          addOrgErrorMessage: getMessage("EMPTY_MESSAGE")
        }
      });
    }
    else if (this.state[targetStorage].isVerified) {
      let bucket = this.state[targetStorage].storageDetails;
      bucket.type = bucket.type ? bucket.type : "S3";
      bucket.list = bucket.list ? bucket.list : [];
      bucket.location = this.state[targetStorage].storageDetails?.location ? this.state[targetStorage].storageDetails?.location : STORAGE_LOCATION.LOOOKIT_CUSTOM;
          
      let isDuplicateStorageDetails =false;
      bucket.list.map((content, i) =>{
        if (content.credential.bucketName === this.state[targetStorage].bucketName
            && content.credential.id === this.state[targetStorage].id
            && content.credential.secret === this.state[targetStorage].secret
        ) {
          //Duplicate Storage Details
          isDuplicateStorageDetails=true;
        }
      });

      if(!isDuplicateStorageDetails) {
        if (!this.state[targetStorage].isEditStorage) {
          let cred = {
            credential: {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation: { status: true },
            isSelected: this.state[targetStorage].isSelected,
            id: null
          }
          bucket.list.push(cred)
        }
        else {
          let cred = {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation = { status: true }
          bucket.list = bucket.list.map(
            (content, i) => content.credential.bucketName === this.state[targetStorage].bucketName ? {
              ...content, credential: cred, validation: validation
            } : content)
        }
        this.resetStorageDetailsFields(targetStorage);
        this.setState((state, props) => {
          return{
            [targetStorage]: {
              ...state[targetStorage],
              storageDetails: bucket,
            }
          }
        })
      }
      else {
        this.setState({
          [targetStorage]: {
            ...this.state[targetStorage],
            addOrgErrorMessage: getMessage("DUPLICATE_STORAGE_CREDENTIALS"),
          }
        });
      }
    }
    else {
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          addOrgErrorMessage: getMessage("BEFORE_VERIFICATION_ERROR"),
        }
      });
    } 
  }

  handleVerifyStorageDetailsClick = (targetStorage) => {
    this.resetError(targetStorage);
    if (this.state[targetStorage].bucketName &&
        this.state[targetStorage].id && 
        this.state[targetStorage].secret
    ) {
      this.setState({ spinnerVisibility: true });
      let storage = {
        type: 'S3',
        credentials: {
          id: this.state[targetStorage].id,
          secret: this.state[targetStorage].secret,
          bucketName: this.state[targetStorage].bucketName
        }
      }
      this.props.verifyStorage(storage, (error) => {
        if (error.code)
          this.setState(
            { spinnerVisibility: false,
              [targetStorage]: {
                ...this.state[targetStorage],
                isVerified: false,
                addOrgErrorMessage: getMessage(error.code),
              }
            }
          )
        else {
          this.setState(
            { spinnerVisibility: false,
              [targetStorage]: {
                ...this.state[targetStorage],
                isVerified: true,
                addOrgErrorMessage: ""
              }
            }
          )
        }
      })
    }
    else {
      this.setState({ 
        [targetStorage]: {
          ...this.state[targetStorage],
          addOrgErrorMessage: getMessage("EMPTY_MESSAGE")
        }
      });
    }
  }

  onChangeStorageOption = (event, targetStorage) => {
    let selectedStorage = event.target.value;
    this.resetError(targetStorage);
    this.resetStorageDetailsFields(targetStorage);
    this.setState((state, props) => {
      let obj = state[targetStorage].storageDetails ? state[targetStorage].storageDetails : {};
      if (obj) {
        obj.location = selectedStorage == "Select" ? null : selectedStorage;
        obj.list = obj.list ? obj.list : [];
        return{
          [targetStorage]: {
            ...state[targetStorage],
            storageDetails: obj
          },
        }
      }
    });
  }
  cancelStorage = (targetStorage) => {
    this.resetStorageDetailsFields(targetStorage);
    this.resetError(targetStorage);
  }

  isOutsideRange = (day) => {
    let dayIsBlocked = false;
    //Block past dates
    if(getTomorrowDate().diff(day.startOf('day'), 'days') > 0) {
      dayIsBlocked = true;
    }
    return dayIsBlocked;
  }

  handleSwitches=(toggleFlag,variable)=>{
    if(variable !== "ALLOW_DOWNLOAD" && variable !== "PDF" && variable !== "RECORDING" && variable !== "SUPPORT_CENTER"){ 
      this.setState((prevState) => ({ [variable]: !prevState[variable] }));
      if (variable =="isSSOEnabled" && this.state.isMfaEnabled) {
        this.handleMfaSwitches(false)
      }
    }
    else{
      let state_element = this.state.OrgDetail.availableModules;
      if (toggleFlag && !(variable in state_element)) {
            
        state_element.push(variable);
      } else if (!toggleFlag) {
        state_element = _.remove(state_element, item => {
          if (item !== variable) return item;
        });
      }
      let OrgDetail = this.state.OrgDetail;
      OrgDetail.availableModules = state_element;
      this.setState({ OrgDetail: OrgDetail, errorMessage: "" });
    }
  }

  displayAllModuleList = () => {
    let allModuleList = [];

    _.map(modulesToDisplay, (key, value) => {

      switch (key) {
        case "CANVAS":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="CANVAS"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_canvas}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "AUDIO":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="AUDIO"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_audio}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("AUDIO")}
              </Label>
            </Col>
          );
          break;  
        case "AUDIO_VIDEO":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="AUDIO_VIDEO"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_video}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("VIDEO")}
              </Label>
            </Col>
          );
          break;
        case "SCREENSHARE":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="SCREENSHARE"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_share}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "MSG":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="CHAT"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_message}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "LOCATION":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="LOCATION"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_location}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "PDF_EDITOR":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="PDF"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_pdf}
                  style={{
                    height: "17px",
                    width: "17px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "SNAP_SHOT":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="SNAPSHOT"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_camera}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "QR_CODE":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="QR_CODE"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_QR_code}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("QR_CODE")}
              </Label>
            </Col>
          );
          break;
        case "ALLOW_DOWNLOAD":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="ALLOW_DOWNLOAD"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={download_img}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "CO_BROWSE":
          allModuleList.push(
            <>
            <Col key={key} xs={12} lg={4}>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="CO_BROWSE"
                  onChange={this.changeModulePermission}
                />
                <img
                  src={ic_admin_co_browse}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("CO_BROWSE")}
              </Label>
            </Col>
            {this.state.OrgDetail.availableModules.includes(modulesAvailableConstant.CO_BROWSE) && 
            <Col xs={12} lg={6} className="noPadding">
              <Input
                type="select"
                name="cobrowseType"
                id="cobrowseType"
                className="inputFormControl"
                onChange={this.handleInputChange}
                value={this.state.orgDetail?.cobrowseType}
              >
                <option className="inputFormControl" value={cobrowseTypes.CUSTOMER_CO_BROWSE}>{getMessage("CUSTOMER_CO_BROWSE")}</option>
                <option className="inputFormControl" value={cobrowseTypes.CUSTOMER_CO_BROWSE_V2}>{getMessage("CUSTOMER_CO_BROWSE_V2")}</option>
              </Input>
            </Col>
            }
          </>
          );
          break;
      }
    });

    return allModuleList;
  };

  renderButtons = () => {
    return (
      <div>
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>{" "}
        <Button
          onClick={this.handleAddClick}
          className="buttons customBtn whiteOnClick"
        >
          {getMessage("ADD")}
        </Button>
      </div>
    );
  };

  renderSprinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  renderSwitch = (flag,variable)=>{
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={(event)=>{this.handleSwitches(event,variable)}}
      />
    )
  }

  renderMfaSwitch = (flag)=>{
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={(event)=>{this.handleMfaSwitches(event)}}
        className="modal-label"
      />
    )
  }

  handleMfaSwitches=(toggleFlag)=>{
    for(let i=0; i<this.state.OrgDetail.availableModules.length; i++){
      if(this.state.OrgDetail.availableModules[i] == 'MFA'){
        this.state.OrgDetail.availableModules.splice(i, 1);
      }
    }
    if (toggleFlag) {
      this.state.OrgDetail.availableModules.push('MFA')
      if (this.state.isSSOEnabled){
        this.handleSwitches(false,"isSSOEnabled")
      }
    }
    this.setState({
      isMfaEnabled: toggleFlag
    })
  }

  renderStorageDetailSetting = (targetStorage) => {
    return(
      <>
        {
          this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.LOOOKIT_CUSTOM ?
            <div className="section">
              <Row className="noMargin">
                <Col className="mainTitleStorage pl-0 label">{getMessage("STORAGE")}
                </Col>
                { (!this.state[targetStorage].isAddStorage && !this.state[targetStorage].isEditStorage) &&
                  (this.state[targetStorage].storageDetails.location === STORAGE_LOCATION.LOOOKIT_CUSTOM) ?
                  <Col className="mainTitleStorage pr-0">
                    <img
                      src={ic_add_storage}
                      className="cursorPointer floatRight"
                      onClick={() => this.setState({
                        [targetStorage]: { 
                          ...this.state[targetStorage],
                          isAddStorage: true 
                        }
                      })}
                      data-toggle="tooltip"
                      data-placement="top"
                      title={getMessage("ADD_STORAGE")}
                    />
                  </Col>
                  : null
                }
              </Row>
              <div>
                {this.state[targetStorage].storageDetails.list ?
                  <Row className="storageCard">
                    <CardBody className="pt-0 pb-0">
                      <Row className="interCardContent">
                        <Table bordered size="sm" className="ml-2 mr-2 storageTableWidth">
                          <thead>
                            <tr className="storageHead">
                              <th className="storageRow border-bottom rounded"> </th>
                              <th className="storageRow border-bottom rounded" colSpan="2">{getMessage("BUCKET_NAME")}</th>
                              <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("ID")}</th>
                              <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("SECRET")}</th>
                              <th className="storageRow border-bottom rounded"> </th>
                              <th className="storageRow border-bottom rounded"> </th>
                            </tr>
                          </thead>
                          {this.renderStorageTableBody(targetStorage)}
                        </Table>
                      </Row>
                    </CardBody>
                  </Row>
                  : null}
                {this.state[targetStorage].isEditStorage || this.state[targetStorage].isAddStorage ?
                  <Row>
                    <Col className="storageCard">
                      <Card>
                        <CardBody>
                          <Row className="radio">
                            <Col>
                              <Label className="label">{getMessage("AWS_S3")}:</Label>
                            </Col>
                            <Col>
                              <Button
                                close aria-label="Cancel"
                                onClick={() => {
                                  this.cancelStorage(targetStorage);
                                }}
                              >
                              </Button>
                            </Col>
                          </Row>
                          <Row className="interCardContent">
                            <Col xs={4} className="pt-4 align-self-center">
                              <Label>{getMessage("BUCKET_NAME")}</Label> </Col>
                            <Col xs={8}>
                              <Input
                                type="text"
                                name="bucketName"
                                className="inputFormControl mt-3"
                                maxLength="50"
                                required
                                disabled={this.state[targetStorage].currentBucket}
                                onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                value={this.state[targetStorage].bucketName}
                              />
                            </Col>
                          </Row>
                          <Row className="interCardContent">
                            <Col xs={4} className="pt-4 align-self-center">
                              <Label>
                                {getMessage("ID")}
                              </Label>
                            </Col>
                            <Col xs={8}>
                              <Input
                                type="text"
                                name="id"
                                className="inputFormControl mt-3"
                                maxLength="50"
                                required
                                onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                value={this.state[targetStorage].id}
                              />
                            </Col>
                          </Row>
                          <Row className="interCardContent">
                            <Col xs={4} className="pt-4 align-self-center">
                              <Label>
                                {getMessage("SECRET")}
                              </Label>
                            </Col>
                            <Col xs={8}>
                              <Input
                                type="password"
                                name="secret"
                                className="inputFormControl mt-3"
                                maxLength="50"
                                required
                                onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                value={this.state[targetStorage].secret}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col  className="errors autoHeight col-md-12">
                              {getMessage(this.state[targetStorage].addOrgErrorMessage)}
                            </Col>
                          </Row>
                          <Row className="interCardContent floatRight">
                            <Button
                              onClick={() => this.handleVerifyStorageDetailsClick(targetStorage)}
                              disabled={!this.state[targetStorage].isVerified ? false : true}
                              className={this.state[targetStorage].isVerified ? "verifiedBtn mt-2 " : "verifyBtn mt-2"}>
                              {this.state[targetStorage].isVerified ? getMessage("VERIFIED") : getMessage("VERIFY")}
                            </Button>
                            <Button className={this.state[targetStorage].isVerified ? "borderBtn cursorPointer bgwhite ml-3 mt-2" : "disabledBtn ml-3 mt-2"}
                              disabled={this.state[targetStorage].isVerified ? false : true}
                              onClick={() => this.addStorage(targetStorage)}
                            >
                              {this.state[targetStorage].isEditStorage ? getMessage("UPDATE") : getMessage("ADD")}
                            </Button>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  : null}
              </div>
              {this.state[targetStorage].storageErrorMessage ? <Row><Col md={{span:8,offset:4}} className="errors autoHeight col-md-12">{getMessage(this.state[targetStorage].storageErrorMessage)}</Col> </Row> : null}
            </div>
            : null
        }
        {this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.LOOOKIT_CUSTOM && 
          !this.state[targetStorage].isStorageSelected && (!this.state[targetStorage].isEditStorage && !this.state[targetStorage].isAddStorage) ?
          <Row><Col md={12} className="warning autoHeight">
            {targetStorage === STORAGE.STORAGE 
              ? getMessage("FIRST_LOOOKIT_CUSTOM_WARNING")
              : getMessage("FIRST_LOOOKIT_CUSTOM_WARNING_RECORDING")}
          </Col> </Row>
          : null}
        {((this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER) &&
          (!this.state[targetStorage].storageDetails?.otherStorageValid)) ?
          <Row><Col md={12} className="warning autoHeight">{getMessage("CUSTOMER_WARNING")}</Col> </Row>
          : null}
        {this.state[targetStorage].storageChanged ?
          <Row><Col md={12} className="text-muted text-center autoHeight">
            {targetStorage === STORAGE.STORAGE 
              ? getMessage("SECOND_LOOOKIT_CUSTOM_WARNING")
              : getMessage("SECOND_LOOOKIT_CUSTOM_WARNING_RECORDING")}
          </Col> </Row>
          : null
        }
      </>
    )
  }

  renderStorageTableBody(targetStorage) {
    return (
      <tbody>
        {this.state[targetStorage].storageDetails.list?.map((item, index) =>
          <tr className="cursorPointer">
            <td className="storageRow">
              <Input
                type="radio"
                className='oldRadio'
                checked={item.isSelected}
                onChange={() => this.selectDefaultStorage(index, targetStorage)}
              />
              <span className="checkmark" value={item.isSelected}
                onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              </span>
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="2"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential.bucketName}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential.id}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              ****************************************
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              {!item.validation.status ?
                <img src={ic_error} alt="Status" className="ml-2 cursorPointer"
                  id="bucketError" data-toggle="tooltip" data-placement="bottom"
                  title={item.validation.error.message} />
                : null
              }
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              <img src={ic_edit} alt="Edit" className="cursorPointer"
                onClick={() => { this.handleEditStorageClick(item.credential.bucketName) }} />
            </td>
          </tr>)
        }
      </tbody>
    )
  }

  getSystemCapacity = () => {
    return (this.props.sessionsCapacity.systemMaxCapacity - this.props.sessionsCapacity.usedCapacity);
  }

  displaySystemCapacityUI = () => {
    return (
      <Col xs={3} className="d-flex modal-label">
        <span  className="p-0 modal-label systemCapacityLabel"> {getMessage("SYSTEM_CAPACITY")}: </span>
        <span className="modal-label ml-1 systemCapacityValue"> {this.getSystemCapacity()}</span>
      </Col>
    )
  }

  showOrHideSystemCapacity = (showSystemCapacity) =>{
    this.setState({
      showSystemCapacity: showSystemCapacity,
    });
  }

  renderNoOfSeats = () => {
    return (
      <Row className="mb-2">
        <Col xs={3} className="pr-0">
          <Label className="label modal-label">{getMessage("NO_OF_SEATS")}</Label>
        </Col>
        <Col xs={6} className="parentOfNumericInput">
          <NumericInput
            className="ml-1 inputFormControl"
            name="seats"
            value={this.state.OrgDetail.seats}
            min={0}
            strict={this.state.OrgDetail.seats <= 9999999}
            onChange={(value) => this.handleNumberInputChange("seats", value, 9999999)}
            // onFocus={() => this.showOrHideSystemCapacity(true)}
            onBlur={() => this.showOrHideSystemCapacity(false)}
            required
          />
        </Col>
        {this.state.showSystemCapacity && this.displaySystemCapacityUI()}
      </Row>
    )
  }

  renderMaxConcurrentConnections = () => {
    return (
      <Row className="mb-2">
        <Col xs={3} className="pr-0">
          <Label className="label modal-label">{getMessage("MAX_CONCURRENT_CONNECTIONS")}</Label>
        </Col>
        <Col xs={6} className="parentOfNumericInput">
          <NumericInput
            className="ml-1 inputFormControl"
            value={this.state.OrgDetail.maxConcurrentConnections}
            min={0}
            strict={this.state.OrgDetail.maxConcurrentConnections <= 9999999}
            name="maxConcurrentConnections"
            onChange={(value) => this.handleNumberInputChange("maxConcurrentConnections", value, 9999999)}
            // onFocus={() => this.showOrHideSystemCapacity(true)}
            onBlur={() => this.showOrHideSystemCapacity(false)}
            required />
        </Col>
        {this.state.showSystemCapacity && this.displaySystemCapacityUI()}
      </Row>
    )
  }

  render() {
    return (

      <div>
        {this.renderSprinner()}
        <div
          backdrop="static"
          className="addOrganisationModal p-3 whiteBackground"
        >
          {/* <ModalBody> */}
          <Form>
            <FormGroup>
              <Label className="label modal-label">
                {getMessage("ORGANIZATION_NAME")}
              </Label>
              <Input
                type="text"
                name="name"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("BUSINESS_MODELS")}</Label>
              <Input
                type="select"
                name="businessModel"
                id="businessModel"
                className="inputFormControl"
                onChange={this.handleInputChange}
                value={this.state.OrgDetail.businessModel}
              >
                <option className="inputFormControl" value={BUSINESS_MODELS.NUMBER_OF_SEATS}>{getMessage("NO_OF_SEATS")}</option>
                <option className="inputFormControl" value={BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS}>{getMessage("MAX_CONCURRENT_CONNECTIONS")}</option>
              </Input>
            </FormGroup>
            {
              this.state.OrgDetail.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS 
                ? this.renderNoOfSeats()
                : this.renderMaxConcurrentConnections()
            }
            <FormGroup>
              <Label className="label modal-label">{getMessage("ORGANIZATION_URI_IDENTIFIER")}</Label>
              <Input
                type="text"
                maxLength="50"
                name="uriIdentifier"
                className="inputFormControl"
                placeholder={getMessage("ORGANIZATION_URI_IDENTIFIER")}
                onChange={this.handleInputChange}
                value={this.state.OrgDetail.uriIdentifier}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label" style={{ alignSelf: "flex-start" }}> {getMessage("AVAILABLE_FEATURE")}</Label>
              <Row className="flex5 moduleRow" >
                <Col xs={5} className="d-flex noPadding modal-label">
                  <Label className="label modal-label"> {getMessage("SINGLE_SIGN_ON")}</Label>
                  {this.renderSwitch(this.state.isSSOEnabled,"isSSOEnabled")}
                </Col>
                <Col xs={5} className="ml-5 d-flex modal-label">
                  <Label className="label p-0 mr-5 modal-label"> {getMessage("SPECIFIED_MEETING_CODE")}</Label>
                  {this.renderSwitch(this.state.isPasscodeEnabled,"isPasscodeEnabled")}
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <div className="label"></div>
              <Row className="flex5 moduleRow" >
                <Col xs={5} className="d-flex noPadding modal-label">
                  <Label  className="label p-0 modal-label"> {getMessage("ORGANIZATION_TEMPLATE")}</Label>
                  {this.renderSwitch(this.state.isOrganizationTemplatesEnabled,"isOrganizationTemplatesEnabled")}
                </Col>
                <Col xs={5} className="ml-5 d-flex modal-label">
                  <Label className="label p-0 mr-5 modal-label"> {getMessage("PDF_EDITOR")}</Label>
                  {this.renderSwitch(this.state.OrgDetail &&
                    this.state.OrgDetail.availableModules &&
                    this.state.OrgDetail.availableModules.includes("PDF"),"PDF")}
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <div className="label"></div>
              <Row className="flex5 moduleRow" >
                <Col xs={5} className="d-flex noPadding modal-label">
                  <Label className="label p-0 modal-label"> {getMessage("ALLOW_DOWNLOAD")}</Label>
                  {this.renderSwitch(this.state.OrgDetail.availableModules && this.state.OrgDetail.availableModules.includes("ALLOW_DOWNLOAD"),"ALLOW_DOWNLOAD")}
                </Col>
                <Col xs={5} className="ml-5 d-flex modal-label">
                  <Label className="label p-0 mr-5 modal-label"> {getMessage("ALLOW_SMS")}</Label>
                  {this.renderSwitch(this.state.isSMSEnabled,"isSMSEnabled")}
                </Col>
              </Row>
            </FormGroup> 

            <FormGroup>
              <div className="label"></div>
              <Row className="flex5 moduleRow">
                <Col xs={5} className="d-flex noPadding modal-label">
                  <Label className="label p-0 modal-label"> {getMessage("AUDIO_VIDEO_RECORDING")}</Label>
                  {this.renderSwitch(this.state.OrgDetail.availableModules && this.state.OrgDetail.availableModules.includes("RECORDING"),"RECORDING")}
                </Col>
                <Col xs={5} className="ml-5 d-flex modal-label">
                  <Label className="label modal-label p-0 mr-5"> {getMessage("MFA")}</Label>
                  {this.renderMfaSwitch(this.state.isMfaEnabled)}
                </Col>
              </Row>
            </FormGroup> 

            <FormGroup>
              <div className="label"></div>
              <Row className="flex5 moduleRow">
                <Col xs={5} className="d-flex noPadding modal-label">
                  <Label className="label modal-label p-0 mr-5"> {getMessage("SUPPORT_CENTER")}</Label>
                  {this.renderSwitch(this.state.OrgDetail.availableModules && this.state.OrgDetail.availableModules.includes("SUPPORT_CENTER"),"SUPPORT_CENTER")}
                </Col>
                {/* <Col xs={5} className="ml-5 d-flex modal-label">
                  <Label className="label modal-label p-0 mr-5"> {getMessage("SUPPORT_CENTER")}</Label>
                  {this.renderMfaSwitch(this.state.isMfaEnabled)}
                </Col> */}
              </Row>
            </FormGroup>

            <FormGroup>
              <Label className="label" style={{ alignSelf: "flex-start" }}>
                {getMessage("AVAILABLE_MODULE")}
              </Label>
              <Row className="flex5 moduleRow">{this.displayAllModuleList()}</Row>
            </FormGroup>
            {
              this.state.OrgDetail.availableModules &&
              this.state.OrgDetail.availableModules.indexOf("QR_CODE") !== -1 ?
                <FormGroup>
                  <Label className="label modal-label">{getMessage("QR_CODE_LIMIT")}</Label>
                  <NumericInput
                    name="qrLimit"
                    value={this.state.OrgDetail.qrLimit}
                    min={0}
                    strict={this.state.OrgDetail.qrLimit <= 10}
                    onChange={(value) => this.handleNumberInputChange("qrLimit", value, 10)}
                    className="ml-1 inputFormControl"
                    required />
                </FormGroup> : null
            }
            <FormGroup className="d-flex justify-content-between">
              <Label className="label modal-label">{getMessage("EXPIRY_DATE")}</Label>
              <div className="col-9 pl-4 pr-0">
                <SingleDatePicker
                  date={this.state.OrgDetail.licenseExpiryDate} 
                  onDateChange={this.handleDateChange} 
                  focused={this.state.focused}
                  onFocusChange={({ focused }) => this.setState({ focused })} 
                  numberOfMonths={1}
                  id="licenseExpiryDate"
                  showDefaultInputIcon={false}
                  displayFormat="YYYY/MM/DD"
                  monthFormat={getMessage("DATE_PICKER_FORMAT")}
                  verticalSpacing={0}
                  isOutsideRange={this.isOutsideRange}
                  hideKeyboardShortcutsPanel
                  block noBorder
                />
              </div>
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("LOGGING_LEVEL")}</Label>
              <Input
                type="select"
                name="loggingLevel"
                id="loggingLevel"
                className="inputFormControl"
                onChange={this.handleInputChange}
                value={this.state.OrgDetail.loggingLevel}
              >
                <option className="inputFormControl" value={LOG_TYPE.BASIC}>{getMessage("LOG_TYPE_BASIC")}</option>
                <option className="inputFormControl" value={LOG_TYPE.ADVANCED}>{getMessage("LOG_TYPE_ADVANCED")}</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label className="label modal-label">{getMessage("STORAGE_OPTION")}</Label>
              <Input
                type="select"
                name="storageLocation"
                id="storageLocation"
                className="inputFormControl"
                onChange={(event) => this.onChangeStorageOption(event, "storage")}
                value={this.state.storage.storageDetails?.location}
              >
                <option className="inputFormControl">{getMessage("SELECTION")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_GLOBAL}>{getMessage("LOOOKIT_GLOBAL")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_CUSTOM}>{getMessage("LOOOKIT_CUSTOM")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.CUSTOMER}>{getMessage("CUSTOMER")}</option>
              </Input>
            </FormGroup>
            {this.renderStorageDetailSetting("storage")}
            <DropdownItem divider />

            <FormGroup>
              <Label className="label modal-label">{getMessage("RECORDING_STORAGE_OPTION")}</Label>
              <Input
                type="select"
                name="storageLocation"
                id="storageLocation"
                className="inputFormControl"
                onChange={(event) => this.onChangeStorageOption(event, "recordingStorage")}
                value={this.state.recordingStorage.storageDetails?.location}
              >
                <option className="inputFormControl">{getMessage("SELECTION")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_CUSTOM}>{getMessage("LOOOKIT_CUSTOM")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.CUSTOMER}>{getMessage("CUSTOMER")}</option>
              </Input>
            </FormGroup>
            {this.renderStorageDetailSetting("recordingStorage")}
            <DropdownItem divider />

            <FormGroup className="pt-2">
              <Label className="label modal-label">{getMessage("TYPE_OF_USER")}</Label>
              <Label  className="label ml-4 modal-label" style={{ flex: 5.2 }}>
                {getMessage("ADMIN")}
              </Label>
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("EMAIL")}</Label>
              <Input
                type="email"
                name="username"
                onChange={this.handleInputChange}
                className="inputFormControl"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("LAST_NAME")}</Label>
              <Input
                type="text"
                name="lastName"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("FIRST_NAME")}</Label>
              <Input
                type="text"
                name="firstName"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
                required
              />
            </FormGroup>
          </Form>
          {this.state.errorMessage ? <span className=" errors ">{this.state.errorMessage}</span> : null}
          {/* </ModalBody> */}
          <Row className="permissionButtons">
            {this.renderButtons()}
          </Row>
        </div>
      </div>
    );
  }
}

export default AddOrganisation;
